import { render, staticRenderFns } from "./ScIcon.vue?vue&type=template&id=1799f7e2&scoped=true&"
import script from "./ScIcon.vue?vue&type=script&lang=js&"
export * from "./ScIcon.vue?vue&type=script&lang=js&"
import style0 from "./ScIcon.vue?vue&type=style&index=0&id=1799f7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799f7e2",
  null
  
)

export default component.exports